import { skipToken, useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import { AiIntegrationBedrockProviderConfig } from "../providerConfig";
import { SEARCH_BEDROCK_INFERENCE_PROFILES } from "./gql";

type UseAiIntegrationBedrockInferenceProfilesProps = {
  awsIntegrationId?: string;
  providerConfig?: AiIntegrationBedrockProviderConfig;
};

const useAiIntegrationBedrockInferenceProfiles = ({
  awsIntegrationId,
  providerConfig,
}: UseAiIntegrationBedrockInferenceProfilesProps) => {
  const shouldSkip = !awsIntegrationId || !providerConfig;
  const { data, previousData, error, loading } = useQuery(
    SEARCH_BEDROCK_INFERENCE_PROFILES,
    shouldSkip
      ? skipToken
      : {
          variables: {
            awsIntegration: awsIntegrationId,
            config: providerConfig,
          },
        }
  );

  const profiles = useMemo(() => {
    return data?.bedrockInferenceProfiles || previousData?.bedrockInferenceProfiles || [];
  }, [data, previousData]);

  return {
    profiles,
    error,
    loading,
  };
};

export default useAiIntegrationBedrockInferenceProfiles;
